import React from 'react'
import { CrossClientQueryResultSource } from '../../../../models/CrossClient'
import { formatRelativeDateTime } from '../../../../common/dateUtils'
import { CrossClientResultDetailSourceIcon } from './CrossClientResultSourceIcon'
import { getCrossClientResultDetailSourceLabel } from './utils'

export interface CrossClientResultSourceProps {
  resultSource: CrossClientQueryResultSource
}

export const CrossClientResultSource: React.FC<CrossClientResultSourceProps> = ({ resultSource }) => {
  const retrievedAt = resultSource.retrievedAt ? formatRelativeDateTime(new Date(resultSource.retrievedAt)) : null

  return (
    <div className='d-flex gap-2 paragraph-small ms-1 ps-3'>
      <div className='d-flex gap-1 align-items-center'>
        <CrossClientResultDetailSourceIcon source={resultSource.source} />
        <span>{getCrossClientResultDetailSourceLabel(resultSource.source)}</span>
      </div>
      {retrievedAt ? (
        <>
          <span>•</span>
          <span>As of {retrievedAt}</span>
        </>
      ) : null}
    </div>
  )
}
